var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.7,
    height: 19.7,
    viewBox: "0 0 21.7 19.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder",
    transform: "translate(-1.15 -2.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2706",
    "data-name": "Group 2706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M20,21.85H4A2.853,2.853,0,0,1,1.15,19V5A2.853,2.853,0,0,1,4,2.15H9a.85.85,0,0,1,.707.378L11.455,5.15H20A2.853,2.853,0,0,1,22.85,8V19A2.853,2.853,0,0,1,20,21.85ZM4,3.85A1.151,1.151,0,0,0,2.85,5V19A1.151,1.151,0,0,0,4,20.15H20A1.151,1.151,0,0,0,21.15,19V8A1.151,1.151,0,0,0,20,6.85H11a.85.85,0,0,1-.707-.378L8.545,3.85Z",
    fill: "#00246A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderblue);
export default __webpack_public_path__ + "static/media/folderblue.ee82834d7507e9f4fa0f473c46e72383.svg";
export { ForwardRef as ReactComponent };